<template>
  <Day day="10.12.2017">
    <div slot="page-content">
      <Gallery directory="2017/10" />
      <h2>Puh, war das kalt damals!</h2>
      <p class="center">
        Da braucht man doch gleich einen ... ?
      </p>
    </div>
  </Day>
</template>

<script>
import Gallery from '../Gallery.vue'
import Day from '../Day.vue'

export default {
  name: 'Day10',
  components: {
    Gallery,
    Day
  }
}
</script>
